export function ConfigTiktokPixelCode(id) {
  // Configuring TikTok pixel code
  let code = document.createElement("script");
  code.text =
    "!function (w, d, t) {\n" +
    '  w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var i="https://analytics.tiktok.com/i18n/pixel/events.js";ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=i,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};var o=document.createElement("script");o.type="text/javascript",o.async=!0,o.src=i+"?sdkid="+e+"&lib="+t;var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(o,a)};\n' +
    "\n" +
    "  ttq.load('" +
    id +
    "');\n" +
    "  ttq.page();\n" +
    "}(window, document, 'ttq');";
  document.head.appendChild(code);

  // Log success message
  console.log(`Successfully configured TikTok pixel with code: ${id}`);
}

// export function ConfigTiktokPixelCode(pixelCode) {
//   // Configuring TikTok pixel code
//   (function (w, d, t) {
//     w.TiktokAnalyticsObject = t;
//     const ttq = (w[t] = w[t] || []);
//     ttq.push(["init", pixelCode]);
//     // ttq.track("ViewContent");
//     (function () {
//       const ta = d.createElement("script");
//       ta.type = "text/javascript";
//       ta.async = true;
//       ta.src = "https://analytics.tiktok.com/i18n/pixel/sdk.js";
//       const s = d.getElementsByTagName("script")[0];
//       s.parentNode.insertBefore(ta, s);
//     })();
//   })(window, document, "ttq");
//
//   // Log success message
//   console.log(`Successfully configured TikTok pixel with code: ${pixelCode}`);
// }
